<div *ngIf="!timeDisplay" class="loading-text counter-loading">&nbsp;</div>
<div *ngIf="timeDisplay">{{ timeDisplay }}</div>
